import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import DefaultLayout from "@/layouts/default";
import ActiveMeetsComp from "@/components/meets/active-meets-comp";

const ActiveMeetingsPage = () => {
const { short_code } = useParams();
return (<>
    <DefaultLayout>
        <ActiveMeetsComp _short_code={short_code}/>
    </DefaultLayout>
</>)
}

export default ActiveMeetingsPage